<template>
    <div class="contais">
       <div class="headers">
           <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>房产典当业务</el-breadcrumb-item>
                <el-breadcrumb-item>房产业务复核</el-breadcrumb-item>
            </el-breadcrumb>
       </div>

       <div class="table">
            <el-table

                :data="tableData"
                border
                stripe
                style="width: 100%">
                <el-table-column
                prop="CreateDate"
                label="建当日期"
                width="180">
                </el-table-column>
                <el-table-column
                prop="Dhname"
                label="当户姓名"
                width="180">
                </el-table-column>
                <el-table-column
                prop="Ddedquota"
                label="典当额度">
                </el-table-column>
                 <el-table-column
                prop="DdqxStartDate"
                label="典当开始日期">
                </el-table-column>
                 <el-table-column
                prop="DdqxEndDate"
                label="典当到期日期">
                </el-table-column>
                <el-table-column
                prop="ZhfPrice"
                label="典当综合费率/%">
                </el-table-column>
                <el-table-column
                prop="lx"
                label="典当利息费率/%">
                </el-table-column>
                 <el-table-column
                prop="Fcaddres"
                label="房产地址">
                </el-table-column>
                 <el-table-column
                prop="DyfsGuaranty"
                label="抵押方式">
                </el-table-column>
                 <el-table-column
                prop="CreateUser"
                label="经办人">
                </el-table-column>
                

                 <el-table-column
                    fixed="left"
                    label="操作"
                    width="100">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">补充资料</el-button>
                        <el-button type="text" size="small"  @click="reviewClick(scope.row)">复核</el-button>
                        <el-button type="text" size="small"  @click="deleteClick(scope.row)">删除业务</el-button>
                    </template>
                 </el-table-column>
            </el-table>
       </div>
    </div>
</template>
<script>
export default {
    name:'reviewhouse',

    data(){
        return{
            tableData:[], //待复核数据

        }
    },
    methods:{
        //请求数据
        GetData(){
             this.axios
                    .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
                    env: `${this.userData.env}`,
                    query: `db.collection("house").where({
                        Review:_.eq("")
                    }).limit(1000).get()`
                    }).then(res=>{
                    res.data.data.forEach((element, index, array) => {
                        array[index] = JSON.parse(element)
                    });
                    this.tableData = res.data.data
                        // console.log(res) 
                    })
        },
        //补充资料
        handleClick(event){
            this.$router.push({path:"/House/houseDetail",query:{str: this.$Base64.encode(JSON.stringify(event)),state:0}})   
        },
        //复核按钮
        reviewClick(event){
            this.$router.push({path:"/House/houseDetail",query:{str: this.$Base64.encode(JSON.stringify(event)),state:1}}) 
        },

        //删除业务
        deleteClick(event){

                 this.$confirm('确定删除该业务?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                         this.axios
                    .post("/api/tcb/databasedelete?access_token=" + this.ACCESS_TOKEN, {
                        env: `${this.userData.env}`,
                        query:
                        `db.collection("house").doc("${event._id}").remove()`,
                    }).then(res=>{
                        if(res.data.errcode == 0){
                            this.$notify({
                                title: '删除成功',
                                message: `${event.Dhname}的典当业务已删除`,
                                type: 'success'
                                });

                                this.$router.go(0);
                        }
                    })

                    }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                    });

           
            
        }
    },
    created(){
         this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();

    },
    mounted(){

        setTimeout(()=>{
            this.GetData()
            
        },800)

    }
}
</script>
<style scoped>
.headers{
width: 98.5%;
padding: 15px;
background-color: #ffffff;
}
.table{
    margin: 20px auto;
}
</style>